import { Component, OnInit } from '@angular/core';
import { BookVM, BooksService } from './books.service';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { InitScripts } from '../app.constants';
import { MetamanagerService } from '../metamanager.service';

@Component({
  selector: 'app-books',
  templateUrl: './books.component.html',
  styleUrls: ['./books.component.css']
})

export class BooksComponent implements OnInit {

  books = new Observable<BookVM[]>();
  onlineReadHeader: any;
  abstractbody: any;
  type: any;
  title: any;
  subtitle: any;
  abstractfooter:any;

  constructor(private bookService: BooksService, private route: ActivatedRoute, private router: Router,
    private metaManager: MetamanagerService) {
    new InitScripts().loadScripts();
   }

  ngOnInit(): void {
    this.metaManager.updateMetaTitle("Mahanubhav Books Free Download | sarvadhnya.com",
      "Mahanubhav Panth Books - Easy access to Mahanubhav panth books, Read online, download for free",
      "Mahanubhav book, Mahanubhav books, Mahanubhav panth books, Mahanubhav panth books download, Mahanubhav books free download, Mahanubhav Sahitya, Mahanubhav download");

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.type = this.route.snapshot.paramMap.get('type');
    this.books = this.bookService.getAll(this.type);
    if (this.type == 'books') {
      this.title = 'Download Books'
      this.subtitle = 'Books - <span class="marathi-font">पुस्तके</span>';
    }
    else {
      this.title = 'Download Pothis'
      this.subtitle = 'Pothi - <span class="marathi-font">पोथी</span>';
    }
  }

  download(url: string) {
    window.location.href = (window.location.origin + "/assets/"+url);
  }

  readOnline(url: string, name: string) {
    const iframe = document.getElementById('readOnline') as HTMLIFrameElement;
    iframe.contentWindow?.location.replace("../assets/" + url);
    this.onlineReadHeader = name;
  }

  abstract(body: string, name:string, footer:string) {
    this.onlineReadHeader = name;
    this.abstractbody = body.replaceAll("0123456789","<br>");
    this.abstractfooter = footer.replaceAll("0123456789","<br>");
  }

}
